import * as types from './constants';

export const changeLanguage = (payload) => {
  return {
    type: types.CHANGE_LANGUAGE,
    payload,
  };
};

export const setCampaignsMobile = (payload) => ({
  type: types.CAMPAIGNS_MOBILE,
  payload,
});

export const setCampaignsMobileIndex = (payload) => ({
  type: types.CAMPAIGNS_MOBILE_INDEX,
  payload,
});
